import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  value: "",
  value1: "",
  value2: "",
  value3: "",
  value4: "",
};

const SurgeryFilterSlice = createSlice({
  name: "SurgeryFilter",
  initialState,
  reducers: {
    setSurgeryFilter: (state, action) => {
      state.value = action.payload;
    },
    setSurgeryFilter1: (state, action) => {
      state.value1 = action.payload;
    },
    setSurgeryFilter2: (state, action) => {
      state.value2 = action.payload;
    },
    setSurgeryFilter3: (state, action) => {
      state.value3 = action.payload;
    },
    setSurgeryFilter4: (state, action) => {
      state.value4 = action.payload;
    },
    clearSurgeryFilters: (state) => {
      state.value = "";
      state.value1 = "";
      state.value2 = "";
      state.value3 = "";
      state.value4 = "";
    },
  },
});

export const {
  setSurgeryFilter,
  setSurgeryFilter1,
  setSurgeryFilter2,
  setSurgeryFilter3,
  setSurgeryFilter4,
  clearSurgeryFilters,
} = SurgeryFilterSlice.actions;

export const SurgeryFilterReducer = SurgeryFilterSlice.reducer;
